/**
 * Whether a loaded Paper 2 repeats Paper 1's questions: such a Paper 2 is
 * treated as missing when a TMUA sitting starts.
 */
export function tmuaPaperStemsMatch(paperA, paperB) {
  const stem = (q) => String(q?.question || '')
    .replace(/^Question\s+\d+\s*:\s*/i, '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 240);
  if (!Array.isArray(paperA) || !Array.isArray(paperB) || !paperA.length || !paperB.length) {
    return false;
  }
  const last = Math.min(2, paperA.length - 1, paperB.length - 1);
  return stem(paperA[0]) === stem(paperB[0]) && stem(paperA[last]) === stem(paperB[last]);
}
